"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MooncrateConvoysToMars = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const SellSteel_1 = require("../../moon/SellSteel");
const constants_1 = require("../../constants");
const Turmoil_1 = require("../../turmoil/Turmoil");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const Units_1 = require("../../Units");
class MooncrateConvoysToMars extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.MOONCRATE_CONVOYS_TO_MARS,
            cardType: CardType_1.CardType.EVENT,
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.MARS)),
            tr: { moonLogistics: 1 },
            metadata: {
                description: 'Requires that Mars First are ruling or that you have 2 delegates there. ' +
                    'Raise the Logistic Rate 1 step. All players may sell their steel resources for 3M€ each.',
                cardNumber: 'M60',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.moonLogisticsRate();
                    b.text('X').steel(1).any.colon().megacredits(3).multiplier;
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        let canAffordReds = true;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            canAffordReds = this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
        }
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.MARS)) {
            const meetsPartyRequirements = turmoil.canPlay(player, PartyName_1.PartyName.MARS);
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
                return meetsPartyRequirements && canAffordReds;
            }
            return meetsPartyRequirements;
        }
        let societyCost = player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST;
        if (this.reserveUnits.megacredits > 0)
            societyCost += this.reserveUnits.megacredits;
        return player.canAfford(societyCost);
    }
    play(player) {
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.MARS);
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player, 1);
        const game = player.game;
        game.getPlayers().forEach((player) => {
            game.defer(new SellSteel_1.SellSteel(player));
        });
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonLogisticsRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.MooncrateConvoysToMars = MooncrateConvoysToMars;
//# sourceMappingURL=MooncrateConvoysToMars.js.map